import { useSelector, useDispatch } from 'react-redux';
import { AlertDialog, Avatar, Box, Button, Flex, Text, Card } from '@radix-ui/themes';
import { PersonIcon, ChevronRightIcon } from '@radix-ui/react-icons';
import { useNavigate } from 'react-router-dom';
import { updateUser } from '../../redux/slices/userSlice';
import { updateAccount } from '../../redux/slices/accountSlice';
import { updateStudentAccount } from '../../redux/slices/studentAccountSlice'
import api from '../../api';
import { toast } from 'react-toastify';
import UserAvatar from '../common/UserAvatar';
const GuardianSwitchAccountDialog = ({ open, setOpen }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const account = useSelector((state) => state.account);
  const user = useSelector((state) => state.user);
  const students = useSelector((state) => state.guardian?.students || []);

  console.log('full state:', useSelector((state) => state));
  console.log('guardianAccount:', useSelector((state) => state.guardianAccount));
  console.log('students:', students);

  const handleSwitchAccount = async (student) => {
    try {
      const response = await api.post(`/login-with-id/${student.user.id}`);
      const loginData = response.data;

      localStorage.setItem('guardianUserId', user.details.id);
      localStorage.setItem('authToken', loginData.user.authToken);

      dispatch(updateUser(loginData.user));
      dispatch(updateAccount(loginData.account));
      dispatch(updateStudentAccount(loginData.account))

      setOpen(false);
      navigate('/student');
    } catch (error) {
      console.log('Error switching to student account:', error);
      toast.error("Couldn't switch to student account. Please try again.", {
        position: "bottom-right"
      });
    }
  };

  return (
    <AlertDialog.Root open={open} onOpenChange={setOpen}>
      <AlertDialog.Content style={{ maxWidth: 450 }}>
        <AlertDialog.Title>Switch Account</AlertDialog.Title>
        <AlertDialog.Description size="2">
          Select a student account to switch to
        </AlertDialog.Description>

        <Flex direction="column" gap="3" mt="4">
          {students.length === 0 ? (
            <Text>No student accounts found</Text>
          ) : (
            students.map((student) => (
              <Card key={student.id} p="2" onClick={() => handleSwitchAccount(student)} className="cursor-pointer">
                <Flex direction="row" justify="between" align="center" width="100%">
                  <Flex align="center" gap="2">
                    <UserAvatar user={student.user} size="4" />
                    <Flex direction="column" grow="1">
                      <Text size="2" weight="bold">
                        {student.user?.firstname} {student.user?.lastname}
                      </Text>
                      <Text size="1" color="gray">
                        Student
                      </Text>
                    </Flex>

                  </Flex>
                  <ChevronRightIcon />
                </Flex>
              </Card>
            ))
          )}
        </Flex>

        <Flex gap="3" mt="4" justify="end">
          <AlertDialog.Cancel>
            <Button variant="soft" color="gray">
              Cancel
            </Button>
          </AlertDialog.Cancel>
        </Flex>
      </AlertDialog.Content>
    </AlertDialog.Root>
  );
};

export default GuardianSwitchAccountDialog;

